module.exports = __webpack_public_path__ + "static/media/movify.ab1d60f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/movify.png
// module id = 77
// module chunks = 0